import React, { useEffect, useState } from "react";
import BlogPopup from "../../common/popup/blogPopup";

const Blog = () => {
  const [showModal, setShowModal] = useState(false);
  const [blogs, setBlogs] = useState([]);
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    const fetchBlogData = async () => {
      try {
        const response = await fetch(
          process.env.REACT_APP_BACKEND_KEY + "blogs"
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const responseData = await response.json();
        setBlogs(responseData.blogData); // grab the array!
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchBlogData();
  }, []);

  const showPopup = (blogId) => {
    setShowModal(true);
    const data = blogs.find((p) => p._id === blogId);
    setBlog(data);
  };

  const hidePopup = () => {
    setShowModal(false);
  };

  return (
    <>
      <section
        className="service-style-one blog-style-one space-y-top space-y-bottom"
        id="blogs"
      >
        <div className="container">
          <div className="row gy-5 gx-4">
            <div className="col-lg-6">
              <div className="section-heading">
                <h2>What's New </h2>
                <p>
                  Explore a collection of diverse voices and fresh perspectives
                  shared by writers, thinkers, and storytellers from around the
                  world. From creative musings to thoughtful insights, these
                  blogs reflect a variety of experiences and ideas worth
                  discovering.
                </p>
              </div>
            </div>
            <div className="col-lg-6 ">
              {blogs.map((blog, index) => (
                <div
                  className="blog-card wow fadeInUp"
                  data-wow-delay="0.2s"
                  key={index}
                >
                  <ul className="blog-meta">
                    <li>{blog.date}</li>
                    <li>{blog.writer}</li>
                  </ul>
                  <h4 className="blog-title">
                    <a
                      data-fx="1"
                      data-bs-toggle="modal"
                      data-bs-target="#blogModal"
                      className="block__title"
                      data-img="./assets/images/portfolio/feat-3.webp"
                      onClick={() => showPopup(blog._id)}
                    >
                      {blog.title}
                    </a>
                  </h4>
                  <p className="blog-disc">{blog.heading}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <BlogPopup showBoolean={showModal} onClick={hidePopup} data={blog} />
    </>
  );
};

export default Blog;
